import { ApiRoutes } from '@gr/core/api-routes';
import type {
  BacklinkDto,
  EntityDetailsDto,
  EntityListDto,
  EntityListQuery,
  EntityTypeDto,
  SaveEntityTypeRequestDto,
} from '@gr/core/content/entities/dto';
import type { FieldDefinition } from '@gr/core/content/entities/fields';
import type { OperationResult } from '@gr/utils/operation-result';
import type { HttpClient } from '../../../shared/http/http-client';

export class EntitiesApi {
  constructor(private readonly http: HttpClient) {}

  types(blogId: string): Promise<OperationResult<EntityTypeDto[]>> {
    return this.http.get(ApiRoutes.entities.types(blogId));
  }
  type(blogId: string, typeId: string): Promise<OperationResult<EntityTypeDto>> {
    return this.http.get(ApiRoutes.entities.type(blogId, typeId));
  }
  createType(blogId: string, input: SaveEntityTypeRequestDto): Promise<OperationResult<EntityTypeDto>> {
    return this.http.post(ApiRoutes.entities.types(blogId), input);
  }
  updateType(blogId: string, typeId: string, input: SaveEntityTypeRequestDto): Promise<OperationResult<EntityTypeDto>> {
    return this.http.put(ApiRoutes.entities.type(blogId, typeId), input);
  }
  deleteType(blogId: string, typeId: string): Promise<OperationResult<null>> {
    return this.http.delete(ApiRoutes.entities.type(blogId, typeId));
  }
  postFields(blogId: string): Promise<OperationResult<FieldDefinition[]>> {
    return this.http.get(ApiRoutes.entities.postFields(blogId));
  }
  savePostFields(blogId: string, fields: FieldDefinition[]): Promise<OperationResult<FieldDefinition[]>> {
    return this.http.put(ApiRoutes.entities.postFields(blogId), { fields });
  }
  list(blogId: string, typeId: string, query: EntityListQuery = {}, signal?: AbortSignal): Promise<OperationResult<EntityListDto>> {
    return this.http.get(ApiRoutes.entities.listByType(blogId, typeId), { ...query }, signal);
  }
  get(blogId: string, entityId: string): Promise<OperationResult<EntityDetailsDto>> {
    return this.http.get(ApiRoutes.entities.byId(blogId, entityId));
  }
  create(blogId: string, typeId: string, values: Record<string, unknown>): Promise<OperationResult<EntityDetailsDto>> {
    return this.http.post(ApiRoutes.entities.listByType(blogId, typeId), { values });
  }
  update(blogId: string, entityId: string, values: Record<string, unknown>): Promise<OperationResult<EntityDetailsDto>> {
    return this.http.put(ApiRoutes.entities.byId(blogId, entityId), { values });
  }
  delete(blogId: string, entityId: string): Promise<OperationResult<BacklinkDto[] | null>> {
    return this.http.delete(ApiRoutes.entities.byId(blogId, entityId));
  }
}
